import React from "react"
import Modal from 'react-bootstrap/Modal'
import { useRoster } from '../StudentsContext';
import { Button, Col, Row } from 'react-bootstrap';
import { ModalType } from "../Import";

interface EthnicityProps {
    setModalType: (modalType: ModalType) => void
}

export default function EthnicityForm({ setModalType }: EthnicityProps) {
    return <>
        <Modal.Body className="g-3">
            <Row>
                <h3>Ethnicity Allowed Values</h3>
            </Row>

            <Row>
                <p>White</p>
                <p>Hispanic Origin</p>
                <p>Mideastern/Arab Descent</p>
                <p>Black</p>
                <p>Asican/Pacific Islander</p>
                <p>South Asian</p>
                <p>American Indian/Alaskan Native</p>
                <p>Multi-Racial</p>
                <p>Decline to Answer</p>
            </Row>

            <Row>
                <Col>
                    <Button onClick={() => setModalType("default")}>Return to Import</Button>
                </Col>
            </Row>
        </Modal.Body>
    </>
}
